import { Coupon } from './coupon.model';
import { AngularFirestore } from '@angular/fire/firestore';
import { BaseEntityService } from './base-entity.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CouponService extends BaseEntityService<Coupon> {
  constructor(db: AngularFirestore) {
    super(db, Coupon, "/", "coupons");
  }
}
